var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"game"}},[_c('div',{style:({
      height: _vm.Config.PUZZLE_HEIGHT + 'px',
      width: _vm.Config.PUZZLE_WIDTH + 'px',
    }),attrs:{"id":"puzzle"},on:{"pointerup":_vm.pieceMouseUp,"pointermove":_vm.pieceMouseMove,"pointerleave":_vm.pieceMouseUp}},[_vm._l((_vm.pieces),function(pc){return _c('Piece',{key:pc.id,style:({
        top: pc.pos.x + 'px',
        left: pc.pos.y + 'px',
        zIndex: pc.id == _vm.grabbing ? 200 : pc.id * 10 + 100,
      }),attrs:{"id":'piece-' + pc.id,"shape":pc.shape,"colorId":pc.id + 1},nativeOn:{"pointerdown":function($event){return _vm.pieceMouseDown($event)}}})}),_c('Grid',{style:({
        top: _vm.grid_pos.x + 'px',
        left: _vm.grid_pos.y + 'px',
        zIndex: 10,
      }),attrs:{"light":_vm.light_grid}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.phase1)?_c('div',{key:"phase1",staticClass:"button",style:({
          top: _vm.grid_pos.x + 150 + 'px',
          left: _vm.grid_pos.y + 10 + 'px',
          zIndex: 20,
        }),on:{"click":_vm.lightOn}},[_vm._v(" 確認 ")]):_c('div',{key:"phase2",staticClass:"button",style:({
          top: _vm.grid_pos.x + 150 + 'px',
          left: _vm.grid_pos.y + 10 + 'px',
          zIndex: 20,
        }),on:{"click":_vm.lightOn}},[_vm._v(" 判定 ")])])],2),_c('Hint',{attrs:{"clear":_vm.clear},on:{"nextPhase":function($event){_vm.phase1 = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }